import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useStores } from "@/store";
import qs from "qs";
import "./index.less";
import { getQuery } from "@/service/http";
import InfiniteScroll from "react-infinite-scroller";
import { Restaurant, Deal, Footer, WalkIn, CollectionFilter } from "@/components";
import moment from "moment";
import { isMobile ,debounce} from '@/service/utils';
import { Drawer} from "antd";
import CollectionMap from "../browse/components/collection-map";
import {usePaginatedFetch} from './usePaginatedFetch'

const BASE_URL =
  process.env.REACT_APP_MODE === "PRODUTION"
    ? "https://book.diningcity.asia"
    : "https://staging-book.diningcity.asia";
const PAGE_SIZE = 10;
/**
 * 餐厅集合
 *
 */
const ResCollection = () => {
  const { t } = useTranslation();
  const { restaurantStore, BrowseStore, dealStore, memberStore } = useStores();
  const [mapVisible, setMapVisible] = useState(true);
  const { gid, region, lang, payment, callback,private_token,source } = getQuery();
  const [guide, setGuide] = useState({})
  const [collections, setCollections] = useState([])
  const [resAds, setResAds] = useState([])
  const [regionData, setRegionData] = useState({})
  const [bookingVisible, setBookingVisible] = useState(false)
  const [markerIndex, setMarkerIndex] = useState([])
  const [mapSelectedDeals, setMapSelectedDeals] = useState([])
  const [webUrl, setWebUrl] = useState('')
  const collectionScrollRef = useRef(null)
  const coordsRef = useRef({ lat: '', lng: '' })
  const filterParamsRef = useRef({})
  const { CommonStore } = useStores();
  const [autoFitBounds,setAutoFitBounds] = useState(true)
  const [isClearFilter,setIsClearFilter] = useState(false)
  const [mapArea,setMapArea] = useState({})
  const isPhone = isMobile()
  const mapRef = useRef(null);
  const [extraParams, setExtraParams] = useState({
    page: 1,
    lat: '',
    lng: '',
    sort: 'default',
    per_page: PAGE_SIZE
  })
  const [allQueryParams, setAllQueryParams] = useState({
    page: 1,
    per_page: PAGE_SIZE,
    sort: 'default',
  });

  const { data, loading } = usePaginatedFetch(allQueryParams);

  useEffect(()=>{
    let totalRes = (data || [])
      .filter(item => {
        return !resAds.find(ad => ad.id === item.id)
      })
      .map(item => {
        item.lat_lon = {
          lat: item.lat,
          lon: item.lng
        }
        return item
      })
    setCollections(totalRes)
  },[data])
  useEffect(()=>{
    setExtraParams({
      page: 1,
      lat: '',
      lng: '',
    })
    setMarkerIndex([])
  },[gid])

  const getGeoSuccess = useCallback((position) => {
    const { latitude, longitude } = position.coords
    let curExtraParams = {
      ...extraParams,
      lat: latitude,
      lng: longitude
    }
    coordsRef.current = {
      lat: latitude,
      lng: longitude
    }
    setExtraParams(curExtraParams)
    setAllQueryParams({ ...allQueryParams, ...curExtraParams,  id: guide.id || gid })
    console.log('getGeoSuccess',curExtraParams)
    // BrowseStore.getCityByLocation(latitude, longitude).then(res => {
    //   setRegionData(res)
    // })
  },[extraParams,BrowseStore])

  const getGeoError = useCallback(() => {
    console.log('getGeoError',extraParams)
    setAllQueryParams({ ...allQueryParams, ...extraParams,  id: guide.id || gid })
  },[extraParams])

  const getGuideDetail = () => {
    return restaurantStore.getSmartGuideDetail(gid).then(res => {
      setGuide(res)
      setExtraParams({
        ...extraParams,
        sort: extraParams?.sort || res.sort[0].value
      })
      return res
    })
  }

  const getAdsItems = async (params) => {
    let resAdsRes = []
    // 推广餐厅
    if (guide.item_type === 'restaurant') {
      resAdsRes = await BrowseStore.getResAds({
        region: region,
        collection_id: guide.id || '',
        type: 'restaurant',
        search_word: ''
      })
      resAdsRes = (resAdsRes || []).map(item => {
        item.lat_lon = {
          lat: item.lat,
          lon: item.lng
        }
        return item
      })
      setResAds(resAdsRes)
    }

    // 推广优惠
    if (guide.item_type === 'deal') {
      resAdsRes = await BrowseStore.getDealAds({
        collection_id: guide.id || '',
      })
      resAdsRes = (resAdsRes || []).map(item=>item?.source)
      setResAds(resAdsRes)
    }

    // 广告
    // let adsCount = Math.floor(totalRes.length / 4)
    // if (adsCount > 0 && normalAds.length <= 0) {
    //   let normalAdsRes = await BrowseStore.getNormalAds({
    //     keyword: guide.id,
    //     region: region
    //   })
    //   if (normalAdsRes.length > 0) {
    //     let counter = normalAdsRes.length
    //     for (var i = 0; i < 4; i += counter) {
    //       normalAdsRes.forEach(ad => {
    //         normalAdsRes.push(ad)
    //       })
    //     }
    //   }
    //   normalAds = normalAdsRes
    // }
    // normalAds.forEach((ad, index) => {
    //   let pos = (index + 1) * 10
    //   let item = totalRes[pos - 1]
    //   if (item) {
    //     item.ad = ad
    //   }
    // })

    // setCollections(totalRes)
  }

  const setParams = async (params, isMap = false) => {
    if(!isMap){
      filterParamsRef.current = params
    }
   setMapSelectedDeals([])
   setAllQueryParams({...extraParams, ...mapArea, ...params, id: guide?.id || gid})
  }

  useEffect(() => {
    if (window.screen.width <= 768) {
      setMapVisible(false)
    }

    getGuideDetail()
    let dates = []
    for (let i = 0; i < 14; i++) {
      let curDay = moment().add(i, 'days')
      dates.push({
        value: curDay.format('YYYY-MM-DD'),
        date: curDay.date(), // 日期
        day: curDay.day() // 星期
      })
    }

    if (region) {
      BrowseStore.getCityByRegion(region).then(setRegionData)
    }
  }, [window.screen,gid]);

  useEffect(() => {
    if (guide && guide.id && extraParams.sort) {
      if (navigator.geolocation && (!extraParams.lat || !extraParams.lng)) {
        navigator.geolocation.getCurrentPosition(getGeoSuccess, (error) => {
          console.error("定位失败", {
            code: error.code,
            message: error.message
          });
          getGeoError()
        }, {
          timeout: 30000,
          enableHighAccuracy:true,
          maximumAge: 75000
        })
      }
      if (collections.length === 0) {
        getAdsItems()
      }
    }
  }, [guide, extraParams,gid])


  useEffect(() => {
    let ids = markerIndex.map(mIndex => collections[mIndex].id)
    if (ids.length) {
      const deals = []
      collections.forEach(item=> {
        if(ids.includes(item.id)){
          deals.push(item)
        }
      })
      // setHasMore(false)
      setMapSelectedDeals(deals)
    } else {
      setMapSelectedDeals([])
    }
  }, [markerIndex,gid,extraParams])

  function tapMarkersHandler(indexs) {
    setMarkerIndex(indexs)
  }

  const tapResTimeslot = (item, restaurant) => {
    restaurantStore.getRestaurantById(restaurant.id).then((data) => {
      if (restaurant?.id) {
        const { id } = restaurant;
        const path = `${BASE_URL}/#/restaurants/${id}/reservation?`;
        const private_token = memberStore.private_token;
        const query = qs.stringify({
          lang,
          private_token,
          date: item.date,
          time: item.formated_time,
          seats: extraParams.seats,
          source: source,
          show_group_booking: true
        });
        setWebUrl(path + query)
        setBookingVisible(true)
      };
    });
  }

  const tapDealTimeslot = (item, deal) => {
    dealStore.getDeal(deal.id).then(res => {
      const { restaurant, id, can_buy_voucher } = res;
      let path = `${BASE_URL}/#/restaurants/${restaurant.id}/reservation`;
      const private_token = memberStore.private_token;
      let query = {
        lang,
        private_token,
        deal_id: id,
        top: callback || window.location.href,
        show_group_booking: true,
        date: item.date,
        time: item.formated_time,
        seats: extraParams.seats,
        source: source,
      };
      if (payment && payment !== "undefined") {
        path += "/complete";
        const [reservation_code, reservation_id] = payment.split("___");
        query.reservation_code = reservation_code;
        query.reservation_id = reservation_id;
      }
      setWebUrl(path + "?" + qs.stringify(query))
      setBookingVisible(true)
    })
  }
  const handleMapChange = useMemo(() => debounce((data) => {
    console.log('handleMapChange', data)
    const { northeast, southwest } = data.bounds;
    const pos = {
      right_top_lat: northeast.lat,
      right_top_lng: northeast.lng,
      left_bottom_lat: southwest.lat,
      left_bottom_lng: southwest.lng,
    }
    const localParams = {
      ...pos,
      sort: 'default',
      ...coordsRef.current,
      ...filterParamsRef.current
    };
    setAutoFitBounds(false);
    setMapArea(pos)
    setParams(localParams, true);
  }, 500), [guide.item_type]);


  const isShowTopContent = useMemo(()=>{
    if(isPhone && mapVisible){
      return false;
    }
    return true
  },[isPhone,mapVisible])

  const flexDirection = useMemo(()=>{
    if(!isPhone){
      return "row"
    }
    if(isShowTopContent){
      return "column"
    }else{
      return "column-reverse"
    }
  },[isPhone,isShowTopContent])

  const showDealList = useMemo(()=>{
     return mapSelectedDeals.length > 0 ? mapSelectedDeals : collections
  },[collections,mapSelectedDeals])


  const handleClearFilter = ()=>{
    setMapArea({})
    setIsClearFilter(true)
    if (mapRef.current) {
      mapRef.current.resetView();
    }
  }

  const { domain } = CommonStore.cityDetail;
  const origin = process.env.REACT_APP_MODE === "PRODUTION" ? "https://www.diningcity.cn/" : "https://www.diningcitydeals.com/"
  return (
    <div className="hasFooterContent" key={gid}>
      <InfiniteScroll
        initialLoad={false}
        pageStart={1}
        hasMore={false}
        useWindow={/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)}
      >
        <div className="res-collection" ref={collectionScrollRef}>
        {isShowTopContent ? (
            <React.Fragment>
              {
                <div className='navigation-title'>
                  <div
                    onClick={() => {
                      window.location.href = `/#/home?gid=${gid}&region=${
                        region || 'shanghai'
                      }&lang=${lang}&private_token=${private_token}&callback=${callback}&payment=${payment}`
                      window.top.postMessage(
                        {
                          type: 'other',
                          params: {
                            url: `${domain ? 'https://www.' + domain + '/' : origin}${lang}/${region}`,
                            region,
                            lang
                          }
                        },
                        '*'
                      )
                    }}
                  >
                    {t('Header.Home')}
                  </div>
                  <span>&gt;</span>
                  <div className='navigation-title-selected'>{guide.name}</div>
                </div>
              }
              <div className='collection-name'>
                <h2 style={{ marginBottom: '10px' }}>{guide.name}</h2>
              </div>
              <div className={`banner-box ${guide.header_style === 'image' ? 'hero-banner-box' : ''}`}>
                {guide.header_style !== 'image' && (
                  <React.Fragment>
                    <div className='banner-text'>
                      <div className='cate-name'>{guide.name}</div>
                      <div className='cate-desc'>{guide.description || ''}</div>
                    </div>
                    <div className='banner-cover'></div>
                  </React.Fragment>
                )}

                <div className='map-button' onClick={() => setMapVisible(!mapVisible)}>
                  <i className='icon-map-white'></i>
                  {t('Collection.Map')}
                </div>
                <img
                  className='banner'
                  src={`${
                    isPhone
                      ? guide.app_banner_url && guide.app_banner_url.split('?')[0] + '-gallery'
                      : guide.banner_url && guide.banner_url.split('?')[0] + '-gallery'
                  }`}
                  alt=''
                />
              </div>
              {isPhone && <WalkIn guide={guide} />}
            </React.Fragment>
          ) : (
            <div className='collection-header'>
              <i className="icon icon-arrow-left" onClick={() => setMapVisible(!mapVisible)}/>
              <h4>{collections.length} {guide.item_type === 'restaurant' ? t("RESTAURANT"): t("WEB.Deals")}</h4>
            </div>
          )}
          <CollectionFilter onApply={(params)=>setParams(params)} isClearFilter={isClearFilter} setIsClearFilter={setIsClearFilter} isRestaurant={guide.item_type === 'restaurant'}/>
          <div className="content" style={{ flexDirection:flexDirection}}>
            <div className="collections-box">
                <div className="collections">
                  {
                    resAds.map(rest => {
                      return (
                        <React.Fragment key={rest.id}>
                          { guide.item_type === 'restaurant' && <Restaurant restaurant={rest} region={region} isAd={true} />}
                          { guide.item_type === 'deal' && <Deal deal={rest} isAd={true} bookNowDeals={true} showGet={false}/>}
                        </React.Fragment>
                      )
                    })
                  }
                  {guide.item_type === 'restaurant'
                  ? showDealList.map(rest => {
                      return (
                        <React.Fragment key={rest.id}>
                          <Restaurant restaurant={rest} region={region} tapTimeslot={tapResTimeslot} />
                          {rest.ad ? <AdItem ad={rest.ad} /> : null}
                        </React.Fragment>
                      )
                    })
                  : guide.item_type === 'deal'
                  ? showDealList.map((deal, index) => {
                      return (
                        <React.Fragment key={deal.id}>
                          <Deal deal={deal} odd={index % 2 === 0} bookNowDeals={true} showGet={false} tapTimeslot={tapDealTimeslot} />
                          {deal.ad ? <AdItem ad={deal.ad} /> : null}
                        </React.Fragment>
                      )
                    })
                  : null}
                {showDealList.length === 0 && !loading && (
                  <div className='no-result'>
                    <h4>
                      <i className='icon icon-qa-red'></i>
                      <span>{t('Collection.noResults')}</span>
                    </h4>
                    <p>{t('Collection.tryAdjusting')} </p>
                    <button onClick={handleClearFilter}>
                      {guide.item_type === 'deal' ? t('Collection.showAllDeals') : t('Collection.showAllRestaurants')}
                    </button>
                  </div>
                )}
                </div>
                {/* <div className="load-more">
                  {hasMore && <Loading red></Loading>}
                </div> */}
            </div>
            <div className={`map-box ${mapVisible ? '' : 'hide'}`}>
              {!isPhone && <WalkIn guide={guide}/>}
              <div className="map">
                <CollectionMap
                  ref={mapRef}
                  restaurants={collections}
                  region={regionData}
                  tapMarkers={(indexs) => tapMarkersHandler(indexs)}
                  onMapChange={handleMapChange}
                  autoFitBounds={autoFitBounds}
                />
              </div>
            </div>
          </div>

          {
            (bookingVisible&&!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && <BookingForm webUrl={webUrl} onHide={setBookingVisible} />
          }
        </div >
      </InfiniteScroll>
      <Footer isFixed={true}/>
     {/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && <Drawer
        className="booking-drawer deal-drawer collection-drawer"
        placement="bottom"
        closable={false}
        destroyOnClose
        onClose={() => setBookingVisible(false)}
        visible={bookingVisible}
      >
        <div className="booking-form--collection">
          <div className="booking-form--close">
            <span>{t("WEB.Book now")}</span>
            <i className="icon icon-close" onClick={()=>setBookingVisible(false)}></i>
          </div>
          <iframe id='web_form' src={webUrl} frameBorder='0'></iframe>
        </div>
      </Drawer>}
    </div>
  );
};

const AdItem = ({ ad }) => {
  return (
    <a href={ad.href} target="_blank" className="ad-list-item" style={{ backgroundColor: ad.bg_color }}>
      <div className="cover">
        <img src={ad.image_url} alt="" />
      </div>
      <div className="desc" style={{ color: ad.color ? ad.color : '#000000' }}>
        <div>{ad.description}</div>
      </div>
      <div className="read-more" style={{ backgroundColor: ad.button?.bg_color }}>
        <div className="read-more-btn" style={{ color: ad.button?.color }}>{ad.button.text}</div>
      </div>
    </a>
  )
}

const BookingForm = ({ webUrl, onHide }) => {
  const { t } = useTranslation();
  return (
    <div className="booking-form--mask" onClick={() => onHide(false)}>
      <aside className="booking-form--aside" onClick={e => e.stopPropagation()}>
      <div className="booking-form--close" style={{margin:'15px 0 10px 0'}}>
        <span>{t("WEB.Book now")}</span>
        <i className="icon icon-close" onClick={()=>onHide(false)}></i>
      </div>
        <iframe id="web_form" src={webUrl} frameBorder="0"></iframe>
      </aside>
    </div>
  )
}

export default ResCollection;
